import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import BoligmappaPlusMenuIcon from '@/assets/icons/BoligmappaPlusMenuIcon';
import { Link } from 'react-router-dom';
import { bmPlusNavbarMenu } from '@/structure/menu';
import { getDashboardLinkPrefix } from '@/utils/routes';
import { isNativeEnv } from '@/utils/nativeBridge';

const BoligmappaPlusNavMenu = ({ activeProperty, children }) => {
  const isApp = isNativeEnv();
  const propertyDashboardLinkPrefix = getDashboardLinkPrefix(
    activeProperty?.boligmappaNumber
  );
  if (bmPlusNavbarMenu) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 font-circular">
          <DropdownMenuLabel className="flex text-muted-foreground text-base font-medium px-3 py-[9px] gap-2">
            <BoligmappaPlusMenuIcon />
            Boligmappa+
          </DropdownMenuLabel>
          <DropdownMenuGroup>
            {bmPlusNavbarMenu.map(
              ({
                link,
                title,
                icon: Icon,
                propertyRequired,
                isDisabledInApp,
              }) =>
                (!isApp || !isDisabledInApp) && (
                  <>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                      className="text-base [&>svg]:size-[18px] font-medium px-3 py-[9px] gap-4"
                      asChild
                    >
                      <Link
                        to={
                          !propertyRequired
                            ? link
                            : `${propertyDashboardLinkPrefix}/${link}`
                        }
                      >
                        <Icon />
                        {title}
                      </Link>
                    </DropdownMenuItem>
                  </>
                )
            )}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  return null;
};

export default BoligmappaPlusNavMenu;
